import { render, staticRenderFns } from "./ThePedidos.vue?vue&type=template&id=e6174e9a&scoped=true"
import script from "./ThePedidos.vue?vue&type=script&lang=js"
export * from "./ThePedidos.vue?vue&type=script&lang=js"
import style0 from "./ThePedidos.vue?vue&type=style&index=0&id=e6174e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6174e9a",
  null
  
)

export default component.exports